import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { DResult } from '../models/common.models/dresult.model';
import { DPaging } from '../models/common.models/dpaging.model';
import { PagingInputDTO } from '../models/common.models/pagingInputDTO.model';
import { VideoGetListOutputDTO } from '../models/contents.models/Video.models/VideoGetListOutputDTO.model';
import { VideoGetDetailOutputDTO } from '../models/contents.models/Video.models/VideoGetDetailOutputDTO.model';

@Injectable()
export class VideosSiteService {

    constructor(private http: HttpClient) {

    }

    GetPaging(inputDTO: PagingInputDTO) {
        var urlAddress: string = `${API_ServerAddress}/api/v1/Videos/GetPaging/${inputDTO.pageNumber}/${inputDTO.pageCount}`;
        return this.http.get<DResult<DPaging<VideoGetListOutputDTO>>>(urlAddress);
    }

    GetTop(topCount: number) {
        var urlAddress: string = `${API_ServerAddress}/api/v1/Videos/GetTop/${topCount}`;
        return this.http.get<DResult<VideoGetListOutputDTO[]>>(urlAddress);
    }

    GetById(id: number) {
        var urlAddress: string = `${API_ServerAddress}/api/v1/Videos/GetById/${id}`;
        return this.http.get<DResult<VideoGetDetailOutputDTO>>(urlAddress);
    }
}
